<template>
  <div class="distributionApp" :style="'min-height:'+curHeight+'px;'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="cont" v-if="setDetail != null">
      <div class="card">
        <ul>
          <h2>个人认证信息 <a  @click="toPush(setDetail.id,(setDetail.ty == 1 ? 'rose' : 'tkapply'))">详情<i class="el-icon-arrow-right"></i></a></h2>
          <li>
            <div class="bzj">保证金：<i>￥</i><b>{{setDetail.price}}</b></div>
            <p>
              <span><font color="red">*</font>姓名</span>
              <input type="text" readonly="readonly" :value="setDetail.name" />
            </p>
            <p>
              <span><font color="red">*</font>手机号</span>
              <input type="text" readonly="readonly" :value="setDetail.phone" />
            </p>
            <p>
              <span><font color="red">*</font>加入时间</span>
              <input type="text" readonly="readonly" :value="setDetail.create_time" />
            </p>
          </li>
        </ul>
      </div>
      <ul class="scenic">
        <h1><font color="red">*</font>下级代理</h1>
        <li v-for="(item,i) in setDetail.xj" @click="toPush(item.id,'tkdetail')">
          <div class="title">
            <img class="tx" src="~assets/images/mrtx.jpg"/>
            <div class="conTitle">
              <span>{{item.name}}</span>
              <div class="price">保证金：<i><b>¥</b><b>{{item.price}}</b></i>
              <font v-if="setDetail.ty == 1">下线人数：{{item.total}}</font></div>
              <div class="price">加入时间：<font>{{item.create_time}}</font></div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="none" v-if="setDetail == null">
      <img src="~assets/images/none.png" />
      <p>空空如也~</p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        setDetail:[]
      };
    },
    created(){
      this.userData = localStorage.getItem('user') == null ? [] : JSON.parse(localStorage.getItem('user'));
      
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getretail()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },
      getretail:function(e){
        var that = this;
        this.axios({
          method:'post',
          url:that.$host+'home/ticket/retailList',
          params:{
            user_id:that.userData.id,
          }
        }).then(function(response){
          var res = response.data.data;
          that.setDetail = res;          
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .distributionApp{
    max-width:640px;
    margin:0 auto;
    background:#ececec
  }
  .distributionApp .cont{
    width:100%;
    display:block;
    margin:0 auto;
  }
  .distributionApp .cont .success{
    position:absolute;
    right:0;
    top:20%;
    width:150px;
    z-index:999
  }
  .distributionApp  ul{
    display:block;
    margin:0 auto;
    width:100%
  }
  .distributionApp .scenic h1{
    width:92%;
    margin:0 auto;
    font-size:16px;
    padding:10px 0
  }
  .distributionApp .scenic h1 span{
    font-size:13px;
    font-weight:normal;
    padding-left:10px;
    color:#666
  }
  .distributionApp  ul li{
    display:block;
    width:100%;
    margin-bottom:1px;
    background:#fff;
    width:100%;
    padding:13px 0;
    background-size:20% !important
  }
  .distributionApp  ul li .title{
    position:relative;
    width:100%;
  }
  .distributionApp  ul li .title:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .distributionApp  ul li .title img{
    float:left;
    width:20%;
    border-radius:6px;
    margin-left:3%
  }
  .distributionApp  ul li .title .conTitle{
    float:left;
    width:73%;
    margin-left:2%;
  }
  .distributionApp  ul li .title .conTitle span{
    display:block;
    color:#000;
    width:100%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-size:15px;
    font-weight: 600;
  }
  .distributionApp  ul li .title .conTitle font{
    color:#666;
    font-size:12px;
    padding-left:12px
  }

  .distributionApp  ul li .title .conTitle .price{
    font-size: 12px;
    font-family: PingFang SC;
    color: #666;
    padding-top:11px
  }
  .distributionApp  ul li .title .conTitle .price i{
    color: #f00;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .distributionApp  ul li .title .conTitle .price b{
    font-size:12px;
  }

  .distributionApp .card{
    width:100%;
    display:block;
  }
  .distributionApp .card h2{
    font-size:16px;
    position:relative;
    padding-bottom:10px;
    width:90%;
    margin:0 auto;
    padding-left:2%
  }
  .distributionApp .card h2 a{
    float:right;
    font-weight:normal;
    font-size:13px;
    color:#666
  }
  .distributionApp .card h2:after{
    content:'';
    width: 3px;
    height: 14px;
    background: #141EF1;
    position:absolute;
    left:0px;
    top:4px;
    border-radius: 3px;
  }

  .distributionApp .card ul{
    width:100%;
    display:block;
    margin:0 auto;
    background:#fff;
    padding:15px 0 10px 0
  }
  .distributionApp .card ul li{
    background:#f5f5f5;
    border-radius:6px;
    width:92%;
    margin:0 auto 10px auto;
    position:relative;
    padding-bottom:10px
  }
  .distributionApp .card ul li p{
    height:50px;
  }
  .distributionApp .card ul li p span{
    float:left;
    width:22%;
    height:50px;
    line-height:50px;
    margin-left:5%;
    font-size:15px;
    color:#666
  }
  .distributionApp .card ul li p input{
    float:left;
    line-height:35px;
    font-size:14px;
    height:35px;
    border:none;
    width:67%;
    margin-top:8px;
    padding:0 5px;
    outline:none;
  }
  .distributionApp .card ul li .bzj{
    margin-left:5%;
    padding:15px 0 10px 0;
    font-size:15px;
    font-weight:bold
  }
  .distributionApp .card ul li .bzj i{
    font-size:12px;
    color:#f00
  }
  .distributionApp .card ul li .bzj b{
    font-size:18px;
    color:#f00
  }

  .distributionApp .none{
    text-align:center;
    padding-top:120px;
  }
  .distributionApp .none img{
    display:block;
    margin:0px auto;
    width:100px;
  }
  .distributionApp .none p{
    color:#999;
    font-size:15px;
    padding-top:5px;
    letter-spacing:2px;
  }
</style>